export enum Keys {
  Space = ' ',
  Enter = 'Enter',
  Escape = 'Escape',

  ArrowUp = 'ArrowUp',
  ArrowDown = 'ArrowDown',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',

  Tab = 'Tab',

  Backspace = 'Backspace',
  Delete = 'Delete',
}
